module.exports = __webpack_public_path__ + "static/img/active.892e7d1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zjd_img/active.gif
// module id = oboN
// module chunks = 46